import {
  LANGUAGE,
  USERTYPE_AD,
  DEFAULT_USERTYPE
} from '../constants';

class Player {
  constructor({
    source,
    accountname,
    videoid,
    autoplay,
    author,
    bumperid,
    controls,
    description,
    domain,
    edition,
    link,
    loop,
    longdescription,
    modallayer,
    muted,
    name,
    newsid,
    playerid,
    playlistid,
    playlistorientation,
    playsinline,
    poster,
    template,
    src,
    videoad,
    videolive}, serviceUrl) {

    this.options = {source, accountname, videoid, autoplay, author, bumperid, controls, description, domain, edition, link, loop, longdescription, modallayer, muted, name, newsid, playerid, playlistid, playlistorientation, playsinline, poster, template, src, videoad, videolive};
    this.url     = `${serviceUrl}/videos/source/${source}/account/${accountname}/${videoid}.html`;
  }

  fetch() {
    this.promise = Voonto.ready
      .then(() => {
        return _getPromise.call(this, window.__VOONTO__.getUserType());
      })
      .catch(() => {
          return _getPromise.call(this, DEFAULT_USERTYPE);
      });

    return this.promise;
  }

}

export default Player;

/* Private */

function _getPromise(userType) {
  this.options.videoad = !this.options.videoad ? this.options.videoad : USERTYPE_AD[userType];
  this.url += `?${_buildQueryString.call(this)}`;
  return Voonto.$.ajax(this.url, {dataType: 'html'});
}

function _buildQueryString() {
  var params = [];

  for (let i in this.options) {
    if (this.options[i] || typeof this.options[i] === 'boolean') {
      params.push({
        key: i,
        value: encodeURIComponent(this.options[i])
      });
    }
  }

  params.push({
    key: 'isdesktop',
    value: Voonto.is.desktop()
  });

  params.push({
    key:   'language',
    value: `${LANGUAGE}`
  });

  return params.map((param) => {
    return `${param.key}=${param.value}`;
  }).join('&');
}



// WEBPACK FOOTER //
// ./src/models/player.js